import { ListDto } from "types/dto"
import { ApiService } from "./apiService"



export const getVerificationCodes = async (dto: ListDto) => {
    return await ApiService.get(`verification-codes?page=${dto.page}&size=${dto.size}`);
}

export const deleteVerificationCode = async (verificatoinCodeId: string) => {
    return await ApiService.delete(`verification-codes/${verificatoinCodeId}`);
}